import React from "react";
import { Datagrid, List, TextField } from "react-admin";
import { CustomDateField } from "../../../../Components/CustomDateField";

const ResList = props => {
  return (
    <List
      {...props}
      resource="reserveds/getSubPns"
      basePath="reserveds"
      filter={{ pn__eq: props.pn }}
      perPage={10}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid
        id="guid"
        rowStyle={(record, index) => ({
          backgroundColor: record.pn != record.mainPn ? "#eeee9b" : "white",
        })}
      >
        <TextField source="pn" />
        <TextField source="sn" />
        <TextField source="shelf1" />
        <TextField source="shelf2" />
        <TextField source="tbo" />
        <TextField source="tbr" />
        <CustomDateField source="birthDate" />
        <TextField source="componentAge" />
        <TextField source="condition" />
        <TextField source="location" />
        <TextField source="qtyInTransfer" />
        <TextField source="toLocation" />
        <TextField source="pbhReservedNotes" label={"Reserved Notes"} />
      </Datagrid>
    </List>
  );
};

export default ResList;
